import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { IonIcon, IonItem, IonLabel } from '@ionic/angular';
import { BackendType } from '@raptor-fe/core';
import { ApplicationContextStore } from '@raptor-fe/services';

export type DisplayOptions = 'blue' | 'gtx' | 'tiremaster' | 'never';

@Component({
    selector: 'lib-menu-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (isShownInMenu()) {
            <ion-item class="menu-button no-border" lines="none">
                <ion-label>
                    <ng-content></ng-content>
                </ion-label>
                @if (icon() !== '') {
                    <ion-icon slot="end" class="no-border pr-4" [src]="icon()"></ion-icon>
                } @else {
                    <ion-icon slot="end" [name]="ionIcon()" class="no-border pr-4"></ion-icon>
                }
            </ion-item>
        }
    `,
    styles: [
        `
            .menu-button {
            margin-top: 16px;
            margin-left: 24px;
            margin-right: 24px;
            --background: var(--ion-color-primary);
            --border-radius: 12px;
            --color: white;
            --inner-padding-bottom: 0px;
            --inner-padding-end: 0px;
            --inner-padding-start: 0px;
            --inner-padding-top: 0px;
            --min-height: 72px;
        }`,
    ],
    imports: [IonIcon, IonItem, IonLabel],
})
export class MenuItemComponent {
    private readonly applicationContextStore = inject(ApplicationContextStore);

    /**
     * The icon to be displayed in the menu item.
     */
    public icon = input('');

    /**
     * An ion icon for menu item. Will display svg if regular icon is set and fall back on this else.
     */
    public ionIcon = input('');
    /**
     * The condition when the menu item should be hidden. <br>
     * The default value is `never`, which means the menu item will always be shown.
     */
    hideMenuWhen = input<DisplayOptions[]>(['never']);
    /**
     * A computed property that determines whether the menu item should be shown in the menu.
     */
    protected readonly isShownInMenu = computed(() => {
        if (this.hideMenuWhen().includes('never')) {
            return true;
        }
        if (this.hideMenuWhen().includes('blue') && this.applicationContextStore.backendType() === BackendType.BLUE) {
            return false;
        }
        if (this.hideMenuWhen().includes('gtx') && this.applicationContextStore.backendType() === BackendType.GTX) {
            return false;
        }
        if (this.hideMenuWhen().includes('tiremaster') && this.applicationContextStore.backendType() === BackendType.TIREMASTER) {
            return false;
        }

        return true;
    });
}
